/**
 * @author Maria Osama
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-07-26 11:36:19
 * @description Implementation of the lower part of tabs react component
 * @filename on-panel.tsx
 * edited by:Hadeer Elbanna
 */
import React from "react";
import { getCleanUuid } from "../../utilities/general";
import Mailchimp from "react-mailchimp-form";

/**
 * A React component renders the on-panel.
 *
 * @extends {React.Component<OnPanelProps, OnPanelState>}
 */
export class OnPanel extends React.Component<{}> {
  static instance: number = 0;
  /**
   * Constructor.
   *
   * @param {OnPanelProps} props The props of the component.
   */
  constructor(props: {}) {
    super(props);
    const identifier: string = `newsletter-subscribe-form-${getCleanUuid()}`;
    OnPanel.instance += 1;
    this.state = {};
  }

  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render(): React.ReactNode {
    return (
      <div id="onPanel">
        {OnPanel.instance % 2 !== 0 ? (
          <h3>Join the Movement.</h3>
        ) : (
          <h3>Stay Inspired.</h3>
        )}
        <p>Receive the updates from Radivision directly to your inbox.</p>
        <Mailchimp
          action="https://radivision.us14.list-manage.com/subscribe/post?u=c735e455810145c521bf76b4d&amp;id=f9c2e477d1"
          fields={[
            {
              name: "EMAIL",
              placeholder: "Email address ...",
              type: "email",
              required: true,
            },
          ]}
          // Change predetermined language
          messages={{
            sending: "Sending...",
            success: "Thank you for subscribing!",
            error: "An unexpected internal error has occurred.",
            empty: "You must write an e-mail.",
            duplicate: "Too many subscribe attempts for this email address",
            button:
              OnPanel.instance % 2 !== 0 ? "Sign me up!" : "Sign up today!",
          }}
          // Add a personalized class
          className="d-inline-flex flex-sm-row flex-column"
        />
      </div>
    );
  }
}
